import React, { useEffect, useState } from "react";
import { VitalFormData } from "./VitalFormHistory";
import Loader from "Components/Loader";
import api from "utils/api";
import { Segmented, message } from "antd";
import "./VitalForm.scss";
import utils from "utils";
import VitalHistoryEdit from "./VitalHistoryEdit";
import VitalCharts from "./VitalCharts/VitalCharts";
function VitalFormHistoryDoctor(props) {
  const [load, setLoader] = useState(true);
  const [responseData, setResponseData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("vitalHistory");
  const [formActionState, formAction] = useState(false);
  useEffect(() => {
    if (props?.recorddata) {
      setResponseData(props?.recorddata);
      setLoader(false);
    } else if (props.data.patient_id) {
      api
        .fetch_vitals_history(props?.data?.patient_id)
        .then((response) => {
          if (response.data?.status == 200) {
            setResponseData(response.data.data.results);
            setLoader(false);
          } else {
            setLoader(false);
            message.error(response.data?.message);
          }
        })
        .catch((err) => {
          setLoader(false);
          message.error("something went wrong");
        });
    }
  }, []);
  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };
  const unsavedPopup = (key) => {
    utils.Modal(true, {
      width: "650px",
      // closable: false,
      content: (
        <div className="finish-Consult-Modal">
          <div className="finish-header">Switch Tab</div>
          <div className="finish-wrapper">
            <div className="finish-title">
              There are unsaved changes. Are you sure to switch Tab?
            </div>
            <div className="finish-btns">
              <button
                className="action-yes"
                onClick={() => {
                  setSelectedTab(key), utils.Modal(false);
                }}
              >
                Yes
              </button>
              <button
                className="action-no"
                onClick={() => {
                  utils.Modal(false);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      ),
    });
  };
  return (
    <div className="vitalForm">
      <div class="precription-popup react-screen">
        {(props.from !== "consultation")&&<div class="prescription-header">Vitals History</div>}
        {load ? (
          <Loader />
        ) : (
          <>
            {props?.isChartShow && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Segmented
                  size="large"
                  value={selectedTab}
                  onChange={formActionState ? unsavedPopup : handleTabChange}
                  options={[
                    {
                      label: <div>Vitals History</div>,
                      value: "vitalHistory",
                    },
                    {
                      label: <div>Vitals Chart</div>,
                      value: "vitalChart",
                    },
                    // {
                    //   label: <div>Vital Chart Drop</div>,
                    //   value: "vitalChartDrop",
                    // },
                  ]}
                />
              </div>
            )}
            <div class="prescription-content" style={props && props.style}>
              {selectedTab == "vitalHistory" && (
                <>
                  {responseData && props?.isEditable ? (
                    <VitalHistoryEdit data={responseData} />
                  ) : (
                    <VitalFormData
                      data={responseData}
                      showDate={!props?.recorddata}
                    />
                  )}
                </>
              )}
              {selectedTab == "vitalChart" && (
                <VitalCharts patientDetails={props?.data} />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default VitalFormHistoryDoctor;
